var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83019 5.2897L2.59019 1.0497C2.49722 0.955976 2.38662 0.881582 2.26476 0.830813C2.1429 0.780044 2.0122 0.753906 1.88019 0.753906C1.74818 0.753906 1.61747 0.780044 1.49561 0.830813C1.37375 0.881582 1.26315 0.955976 1.17019 1.0497C0.983936 1.23707 0.879395 1.49052 0.879395 1.7547C0.879395 2.01889 0.983936 2.27234 1.17019 2.4597L4.71019 5.9997L1.17019 9.5397C0.983936 9.72707 0.879395 9.98052 0.879395 10.2447C0.879395 10.5089 0.983936 10.7623 1.17019 10.9497C1.26363 11.0424 1.37444 11.1157 1.49628 11.1655C1.61812 11.2152 1.74858 11.2405 1.88019 11.2397C2.01179 11.2405 2.14226 11.2152 2.26409 11.1655C2.38593 11.1157 2.49675 11.0424 2.59019 10.9497L6.83019 6.7097C6.92392 6.61674 6.99831 6.50614 7.04908 6.38428C7.09985 6.26242 7.12599 6.13172 7.12599 5.9997C7.12599 5.86769 7.09985 5.73699 7.04908 5.61513C6.99831 5.49327 6.92392 5.38267 6.83019 5.2897Z",
    fill: "#A1A9B8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.c7ecf556.svg";
export { ForwardRef as ReactComponent };